import React from 'react';
import { st } from './texte'
const PaymentTable = ({appState, ratedetails, moment, dateFormat}) => {
  const ShowTime = (row) => {
    return row.showtime && moment(row.date, ['YYYYMMDD HH:mm:ss', 'YYYYMMDD']).format('HH:mm') !== '00:00';
  };
  const showtime = Object.keys(ratedetails).some((typ) => Object.keys(ratedetails[typ]).some((k) => ShowTime(ratedetails[typ][k])));
 
  const SubTable = ({typ}) => {
    const list = ratedetails[typ];
    const tx_title = typ?'bwh.rate.titelstrono':'bwh.rate.titelplan';
    
    return (        
      <>
        <tr><td colSpan="3"><b>{st[tx_title]}</b></td></tr>
  {Object.keys(list).sort().map((k)=>{
    const row = list[k];
    var date = '';
    if (row.dateTxt && row.dateTxt.substr(0,3)==='bwh') {
      date = st[row.dateTxt];
    }
    else {
      const d = moment(row.dateTxt, ['YYYYMMDD HH:mm:ss', 'YYYYMMDD']);
      const prefix = typ===0?'bwh.rate.before':'bwh.rate.from';
      date = st[prefix] + ' ' + d.format(dateFormat);
      if (ShowTime(row)) {
        date += ' ' + d.format('HH:mm') + '*';
      }
    }
    if (!row.hasOwnProperty('preisMod')) return null;
    return (
      <tr key={k} >
        <td>{date}</td>
        <td>&nbsp;</td>
        <td align="right">{row.preisMod.toFixed(appState.paymentinfo.decimal)+' '+appState.paymentinfo.waehrung}</td>
      </tr>
    )    
  }
  )}
      
      </>
    )
  }
 
  return (
    <table className="paymentplan">
      <tbody>  
        <SubTable typ={0}  />
        <SubTable typ={1}  />
  {showtime &&
        <tr><td colSpan="3">* {st['bwh.rate.localtime'] || "Times are shown in the property's local time."}</td></tr>
  }
      </tbody>  
    </table>
  ) 
}

export default PaymentTable;
